import React from "react";
import Carousel from "react-multi-carousel";
import { Link } from "gatsby";
import aboutUsImage from "../images/about-us.jpg";
import offeringsImage1 from "../images/offerings1.jpg";
// import offeringsImage2 from "../images/offerings2.jpg";
import offeringsImage3 from "../images/offerings3.jpg";
import offering5 from "../images/offering5.png";
import offering4 from "../images/offering4.png";
import whyChooseUsImage from "../images/why-choose-us.jpg";
import offering2 from "../images/offering2.png";
import offering1 from "../images/offering1.png";
import "react-multi-carousel/lib/styles.css";
import { title } from "process";
import profile from "../images/profile.jpeg";
import femaleProfile from "../images/femaleprofile.jpeg";
import bullet from "../images/bulletpnt.png";
import hero from "../images/hero.png";
import { FaLightbulb } from "react-icons/fa";
import { FaPeopleGroup } from "react-icons/fa6";
import { FaCircleCheck } from "react-icons/fa6";
export default function HeroNew() {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const offerings = [
    {
      id: 1,
      title: "Online Learning Platforms",
      description:
        "Interactive and adaptive platforms designed to cater to diverse learning needs, from K-12 to higher education and professional development.",
      image: offering1,
    },
    {
      id: 2,
      title: "Virtual Classrooms",
      description:
        "Seamless video conferencing and collaboration tools for educators to create engaging and real-time learning experiences.",
      image: offering2,
    },
    {
      id: 3,
      title: "AI-Powered Personalization",
      description:
        "Customized learning paths, performance analytics, and insights powered by artificial intelligence.",
      image: offeringsImage3,
    },
    {
      id: 4,
      title: "Corporate Training",
      description:
        "Tailored solutions for businesses to upskill employees and stay ahead in a competitive marketplace.",
      image: offering4,
    },
    {
      id: 5,
      title: "Learning Management System (LMS)",
      description:
        "Streamline education with powerful admin controls, engaging course content, live classes, and automated evaluations.",
      image: offering5,
    },
  ];

  const achievements = [
    "MSME Registered",
    "15+ successful partnerships with educational institutions and corporations",
    "30,000+ learners and educators benefited",
  ];

  const coreValues = [
    {
      title: "Innovation",
      description: "Pushing the boundaries of what's possible in education.",
    },
    {
      title: "Accessibility",
      description:
        "Ensuring quality learning opportunities for everyone, everywhere.",
    },
    {
      title: "Excellence",
      description:
        "Striving for the highest standards in technology and pedagogy.",
    },
    {
      title: "Collaboration",
      description: "Building meaningful partnerships to maximize impact.",
    },
  ];

  const testimonials = [
    {
      img: profile,
      id: 1,
      feedback:
        "CAE 21 has revolutionized the way we learn and teach. Their innovative tools and platforms are a game-changer!",
      author: "Jane Doe, Principal",
    },
    {
      img: femaleProfile,
      id: 2,
      feedback:
        "The virtual classrooms are seamless and incredibly interactive. Our students love the experience!",
      author: "John Smith, Educator",
    },
  ];

  return (
    <div className="container-custom">
      {/* Hero Section */}
      <div className="hero-section text-center">
        <div className="row align-items-center">
          <div className="col-12 col-md-6  justify-content-center align-items-start bg-white p-5">
            <h1 className="common-heading text-black mb-4 text-start">
              Welcome to CAE 21st Century
            </h1>
            <p className="comman-para text-black mb-4 text-start">
              Competency Assessment and Enhancement 21st Century Private Limited
              (CAE 21) is a dynamic EdTech startup at the forefront of
              transforming education for the digital era. Established in 2023,
              we are committed to creating scalable and impactful learning
              solutions that cater to the evolving needs of students, educators,
              and institutions worldwide.
            </p>
            <Link to="/contact-us" className="btn btn-primary px-4 py-2">
              Contact Us
            </Link>
          </div>
          <div className="col-12 col-md-6">
            <img src={hero} alt="img" className="img-fluid" />
          </div>
        </div>
      </div>

      {/* About Us Section */}
      <div className="mt-5 pt-5 px-0 px-md-5 px-lg-5 px-xl-5" id="about-us">
        <div className="row align-items-center">
          <div className="col-12 col-md-6 mb-4">
            <img
              src={aboutUsImage}
              alt="About CAE 21st Century"
              className="img-fluid rounded"
            />
          </div>
          <div className="col-12 col-md-6">
            <h3 className="common-second-heading mt-4">Our Vision</h3>
            <p className="comman-para">
              To be a global leader in digital education, fostering an inclusive
              and lifelong learning ecosystem that bridges gaps and unlocks
              potential.
            </p>
            <h3 className="common-second-heading mt-4">Our Mission</h3>
            <p className="comman-para">
              To empower learners and educators by delivering innovative digital
              tools and fostering a culture of learning for all.
            </p>
          </div>
        </div>
      </div>

      {/* Our Offerings Section */}
      <div
        className="mt-5 pt-5 px-0 px-md-5 px-lg-5 px-xl-5"
        id="our-offerings"
      >
        <h1 className="common-heading mb-5 text-center">OUR OFFERINGS</h1>
        <div className="row text-center">
          <div className="d-flex flex-row flex-wrap justify-content-center">
            {offerings.map((offering) => (
              <div
                className="col-12 col-md-6 col-lg-4 mb-4 px-2"
                key={offering.id}
              >
                <img
                  src={offering.image}
                  alt={offering.title}
                  className="img-fluid rounded mb-3"
                />
                <h4 className="common-second-heading fw-bold">
                  {offering.title}
                </h4>
                <p className="comman-para">{offering.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Core Values Section */}
      <div className="mt-5 pt-5 px-0 px-md-5 px-lg-5 px-xl-5">
        <h1 className="common-heading mb-5 text-center">CORE VALUES</h1>
        <ul className="comman-para list-unstyled text-center">
          {coreValues.map((value, index) => (
            <li key={index}>
              <strong>{value.title}:</strong> {value.description}
            </li>
          ))}
        </ul>
      </div>

      {/* Achievements Section */}
      <div className="mt-5 pt-5 px-0 px-md-5 px-lg-5 px-xl-5">
        <h1 className="common-heading mb-5 text-center">OUR ACHIEVEMENTS</h1>
        <ul className="comman-para list-unstyled text-center">
          {achievements.map((achievement, index) => (
            <li key={index}>{achievement}</li>
          ))}
        </ul>
      </div>

      {/* Testimonials Section */}
      <div className="mt-5 pt-5 px-0 px-md-5 px-lg-5 px-xl-5">
        <h1 className="common-heading mb-5 text-center">
          WHAT OUR CLIENTS SAY
        </h1>
        <Carousel
          className="carousal-custom"
          responsive={responsive}
          itemClass="carousel-item-padding-40-px"
          swipeable={true}
          draggable={false}
          showDots={false}
          infinite={true}
          autoPlay={true}
          arrows={true}
        >
          {testimonials.map((testimonial) => (
            <div key={testimonial.id}>
              <div className="d-flex justify-content-center align-items-center mb-4">
                <img
                  src={testimonial.img}
                  width="150px"
                  height="150px"
                  alt="img"
                  style={{
                    borderRadius: "80px",
                    border: "5px solid blue",
                    padding: "5px",
                  }}
                />
              </div>
              <p className="comman-para text-center">
                "{testimonial.feedback}"<br /> - {testimonial.author}
              </p>
            </div>
          ))}
        </Carousel>
      </div>

      {/* Why Choose Us Section */}
      <div className="mt-5 pt-5 px-0 px-md-5 px-lg-5 px-xl-5 text-center">
        <h1 className="common-heading mb-5 text-center">WHY CHOOSE US</h1>
        <div className="row">
          <div className="d-flex justify-content-center flex-wrap">
            <div className="col-12 col-md-6 col-lg-4 mt-4">
              <FaLightbulb className="me-2 h3" />
              <br />
              <strong>Innovative Technology:</strong> <br />
              <p className="pt-3">
                {" "}
                Leveraging AI, VR, AR, and blockchain to stay ahead of the
                curve.
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mt-4">
              <FaPeopleGroup className="me-2 h3" />
              <br />
              <strong>Expert Team:</strong> <br />{" "}
              <p className="pt-3">
                {" "}
                A passionate team of educators, developers, and innovators
                driving impactful change.
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-4 mt-4">
              <FaCircleCheck className="me-2 h3" />
              <br />
              <strong>Proven Success:</strong> <br />{" "}
              <p className="pt-3">
                {" "}
                Trusted by schools, universities, and corporate partners for
                delivvering measurable results.{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
